import { RouteSegments } from '../routingClientAdmin.interface';

export const generateTradingServerRoute = (id?: string) => {
  const pageUrl = `/${RouteSegments.Root.Config}/${RouteSegments.Settings.Servers}`;

  if (id) {
    return `${pageUrl}/${id}`;
  }

  return pageUrl;
};
